import React from "react";
import { CSSTransitionGroup } from "react-transition-group";

const FadeAnimation = ({ children, ...props }) => (
  <CSSTransitionGroup
    {...props}
    transitionAppear={true}
    transitionEnter={true}
    transitionLeave={true}
    transitionAppearTimeout={500}
    transitionEnterTimeout={500}
    transitionLeaveTimeout={300}
    transitionName="fade"
  >
    {children}
  </CSSTransitionGroup>
);
export { FadeAnimation };

const SlideInDownAnimation = ({ children, ...props }) => (
  <CSSTransitionGroup
    {...props}
    transitionAppear={true}
    transitionEnter={true}
    transitionLeave={true}
    transitionAppearTimeout={500}
    transitionEnterTimeout={500}
    transitionLeaveTimeout={300}
    transitionName="slideInDown"
  >
    {children}
  </CSSTransitionGroup>
);
export { SlideInDownAnimation };

const SlideInUpAnimation = ({ children, ...props }) => (
  <CSSTransitionGroup
    {...props}
    transitionAppear={true}
    transitionEnter={true}
    transitionLeave={true}
    transitionAppearTimeout={500}
    transitionEnterTimeout={500}
    transitionLeaveTimeout={300}
    transitionName="slideInUp"
  >
    {children}
  </CSSTransitionGroup>
);
export { SlideInUpAnimation };

const AppointmentSummaryAnimation = ({ children, ...props }) => (
  <CSSTransitionGroup
    {...props}
    transitionAppear={true}
    transitionEnter={true}
    transitionLeave={true}
    transitionAppearTimeout={500}
    transitionEnterTimeout={500}
    transitionLeaveTimeout={300}
    transitionName="appointmentSummaryAnimation"
  >
    {children}
  </CSSTransitionGroup>
);
export { AppointmentSummaryAnimation };

const PersonalFormAnimation = ({ children, ...props }) => (
  <CSSTransitionGroup
    {...props}
    transitionAppear={true}
    transitionEnter={true}
    transitionLeave={true}
    transitionAppearTimeout={500}
    transitionEnterTimeout={300}
    transitionLeaveTimeout={300}
    transitionName="personalFormAnimation"
  >
    {children}
  </CSSTransitionGroup>
);
export { PersonalFormAnimation };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/Animation.js